import { ref, computed } from '@vue/composition-api'

// Notification
import store from '@/store'

export default function useScriptGroup() {
  const refScriptGroupListTable = ref(null)

  const loading = ref(false)
  const perPage = ref(10)
  const totalItems = computed(() => store.state.scriptGroup.scriptGroups.length)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)

  const scriptGroups = computed(() => store.state.scriptGroup.scriptGroups)
  const dataMeta = computed(() => ({
    from: perPage.value * (currentPage.value - 1) + (totalItems.value ? 1 : 0),
    to: totalItems.value < perPage.value ? totalItems.value : perPage.value * currentPage.value,
    of: scriptGroups.value.length,
  }))

  // watch([currentPage, perPage, searchQuery], () => {
  //   refetchData()
  // })

  const fetchScriptGroups = () => {
    loading.value = true
    store.dispatch('scriptGroup/fetchScriptGroups')
      .finally(() => {
        loading.value = false
      })
  }

  fetchScriptGroups()

  return {
    loading,
    perPage,
    currentPage,
    totalItems,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refScriptGroupListTable,
    fetchScriptGroups,
    scriptGroups,
  }
}
